import { FaRegTrashAlt } from "react-icons/fa";

const money = (value) => `$${Math.round(Number(value) || 0).toLocaleString()}`;

export const formatTournamentTransactionType = (type, chips = 0, amount = 0) => {
  const normalized = String(type || "").trim().toLowerCase();
  if (normalized === "cashout" && Number(chips) === -1) return "Balance Cashout";
  if (normalized === "cashout" && Number(amount || 0) === 0) return "Eliminated";

  const labels = {
    buyin: "Buyin",
    rebuy: "Rebuy",
    bonus: "Buy-in Bonus",
    addon: "Tournament Add-On",
    buyin_addon: "Buy-in Dealer Add-On",
    rebuy_addon: "Rebuy Dealer Add-On",
    winner_tip: "Winner Tip",
    cash_refill: "Cash Refill",
    cashout: "Cashout",
    payback: "Payback",
    cost: "Cost",
  };

  if (labels[normalized]) return labels[normalized];
  if (!normalized && Number(chips || 0) > 0) return "Add-On";
  return normalized ? normalized.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "Transaction";
};

export const getTournamentTransactionMethodLabel = (tx = {}) => {
  if (tx.eliminated_by_name) return `Eliminated by ${tx.eliminated_by_name}`;

  const type = String(tx.transaction_type || "").toLowerCase();
  const amount = Number(tx.amount) || 0;
  if (type === "cashout" && amount === 0) return "";

  const method = String(tx.method || "").trim();
  if (!method) return "";

  if (type === "winner_tip") {
    return tx.wallet_name ? `Tip to ${tx.wallet_name}` : "Tip in cash";
  }
  if (type === "cash_refill") {
    return tx.wallet_name ? `from ${tx.wallet_name}` : "";
  }

  if (tx.wallet_name) {
    if (type === "cashout") return `from ${tx.wallet_name}`;
    return `to ${tx.wallet_name}`;
  }

  return method.charAt(0).toUpperCase() + method.slice(1);
};

export function TournamentActivityList({
  transactions = [],
  emptyText = "No transactions found.",
  onUndo,
  isSubmitting = false,
}) {
  if (!transactions.length) {
    return <p className="game-empty">{emptyText}</p>;
  }

  const sortedTransactions = [...transactions].sort((a, b) => {
    const aTime = a.timestamp ? new Date(a.timestamp).getTime() : 0;
    const bTime = b.timestamp ? new Date(b.timestamp).getTime() : 0;
    if (aTime !== bTime) return bTime - aTime;

    return (Number(b.id) || 0) - (Number(a.id) || 0);
  });

  return (
    <div className="game-transaction-list">
      {sortedTransactions.map((tx, index) => {
        const amount = Number(tx.amount) || 0;
        const typeLabel = formatTournamentTransactionType(tx.transaction_type, tx.chips, amount);
        const detail = getTournamentTransactionMethodLabel(tx);
        const playerLabel = String(tx.transaction_type).toLowerCase() === "cash_refill"
          ? "Tournament Cash Bag"
          : (tx.player_name || "Unknown");
        const isOutgoing = String(tx.transaction_type).toLowerCase() === "cashout";
        const amountClass = isOutgoing ? "game-text-danger" : "game-text-success";

        return (
          <div key={tx.id || index} className="game-transaction-item">
            <span className="game-transaction-time">
              {tx.timestamp
                ? new Date(tx.timestamp).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
                : ""}
            </span>
            <span className={`game-transaction-amount ${amountClass}`}>
              {money(Math.abs(amount))}
            </span>
            <span className="game-transaction-type">{typeLabel}</span>
            <strong className="game-transaction-player">{playerLabel}</strong>
            {detail && <span className="game-transaction-method">{detail}</span>}
            {tx.timestamp && (
              <span className="game-transaction-date" style={{ marginLeft: "auto" }}>
                {new Date(tx.timestamp).toLocaleDateString(undefined, { month: "numeric", day: "numeric" })}
              </span>
            )}
            {onUndo && (
              <button
                type="button"
                className="game-icon-btn game-icon-btn--sm game-icon-btn--danger"
                title="Undo transaction"
                disabled={isSubmitting}
                onClick={() => onUndo(tx)}
              >
                <FaRegTrashAlt />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
